module.exports = __webpack_public_path__ + "static/ig_banner_06-94ed637f99f5a3457377d1f360a422df.png";